import training1Hero from './training-1/0-w=800.avif';
import training1Week1 from './training-1/1-w=400.avif';
import training1Week2 from './training-1/2-w=400.avif';
import training1Week3 from './training-1/3-w=400.avif';
import training1Week4 from './training-1/4-w=400.avif';
import training1Week5 from './training-1/5-w=400.avif';
import training1Week6 from './training-1/6-w=400.avif';
import training1Week7 from './training-1/7-w=400.avif';
import training1Week8 from './training-1/8-w=400.avif';

/**
 * Bundled training imagery (generic). Used as marquee fallback on the install screen and for
 * unauthenticated/demo flows when Firestore course images are unavailable.
 */
export const training1WelcomeTrainingSummary = {
  heroImageSrc: training1Hero,
  thumbnailSrcs: [
    training1Week1,
    training1Week2,
    training1Week3,
    training1Week4,
    training1Week5,
    training1Week6,
    training1Week7,
    training1Week8,
  ] as const,
} as const;
